import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const hasAllowedSubscription = (subscriptions: any, allowedPlans: string[]) => {
  const list = Array.isArray(subscriptions)
    ? subscriptions
    : subscriptions
      ? [subscriptions]
      : [];

  return list.some(
    (sub) =>
      sub &&
      (sub.status === 'active' || sub.status === 'trialing') &&
      allowedPlans.includes(sub.plan_type)
  );
};

export const MARKETING_SUBSCRIPTION_PLAN_TYPES = [
  'pro',
  'agency',
  'enterprise',
  'upsell',
  'upsell1',
  'upsell2',
  'upsell_light',
] as const;

// Check if user has access to marketing tools
export const hasMarketingAccess = (lifetimeDeal, subscriptions) => {
  // Check lifetime deal with marketing features
  if (
    lifetimeDeal?.status === 'active' &&
    lifetimeDeal.enabled_features &&
    Array.isArray(lifetimeDeal.enabled_features)
  ) {
    if (lifetimeDeal.enabled_features.includes('ob_marketing')) {
      return true;
    }
  }

  // Check active pro/enterprise subscription(s)
  return hasAllowedSubscription(
    subscriptions,
    [...MARKETING_SUBSCRIPTION_PLAN_TYPES]
  );
};

// Check if user has access to manual creation tools
export const hasManualCreationAccess = (lifetimeDeal, subscriptions, isLoading) => {
  if (isLoading) return false;
  // Check lifetime deal with marketing features
  if (lifetimeDeal?.status == 'active') {
    return true;
  }

  // Check active pro/enterprise subscription(s)
  return hasAllowedSubscription(subscriptions, [
    'pro',
    'agency',
    'enterprise',
    'upsell',
    'upsell2',
    'upsell_light',
  ]);
};

// Check if user has access to marketing tools
export const hasPremiumTemplates = (lifetimeDeal, subscriptions) => {
  // Check lifetime deal with marketing features
  if (
    lifetimeDeal?.enabled_features &&
    Array.isArray(lifetimeDeal.enabled_features)
  ) {
    if (lifetimeDeal.enabled_features.includes('ob_premium_templates'))
      return true;
  }

  // Check active pro/enterprise subscription(s)
  return hasAllowedSubscription(subscriptions, [
    'pro',
    'agency',
    'enterprise',
    'upsell',
    'upsell2',
    'upsell_light',
  ]);
};

export const hasAiExpertiseExtractor = (lifetimeDeal, subscriptions) => {
  return true;
};

export const handleButtonClick = (buttonUrl: string) => {
  if (buttonUrl.startsWith('#')) {
    const element = document.querySelector(buttonUrl);
    if (element) {
      const offset = 30;
      const elementPosition = element.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: elementPosition - offset,
        behavior: 'smooth',
      });
    }
  } else {
    window.location.href = buttonUrl || '/';
  }
};

export const getRenderedImageUrl = (
  imageUrl: string | null,
  width: number,
): string | null => {
  if (!imageUrl) return null;
  const params = new URLSearchParams({
    width: String(width),
    quality: '80',
    resize: 'contain',
  });

  return `${imageUrl.replace('/object/', '/render/image/')}?${params.toString()}`;
};
